import { marketingAdministratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { communicationAudiencePageActions } from "./communicationAudiencePageActions";
import { validateRules } from "./audienceRules";
import { communicationAudiencePageConfig } from "./communicationAudiencePageConfig";
import {
  adaptAudience,
  audienceEntityName,
  audienceRulesOf,
  audienceTypeSummary,
  audienceVisibilityRules,
  newAudienceRecord,
  toAudiencePayload,
} from "./communicationAudienceRecord";
import { countBeforeSave } from "./audienceCount";
import { communicationAudiencePageBadges } from "./communicationAudiencePageBadges";
import {
  AudienceBody,
  AudienceExportDownload,
  AudienceExportSize,
} from "./audienceLazy";

export const communicationAudienceRecordDefinition: RecordDefinition = {
  path: "/audience",
  actions: communicationAudiencePageActions,
  entityName: audienceEntityName,
  listRoute: "/audiences",
  backTitle: "Back to audiences",
  allowedRoles: marketingAdministratorRoles,
  config: communicationAudiencePageConfig,
  // The layout is this page's alone: the rules fill the page between two panes.
  authorable: false,
  body: AudienceBody,
  badges: communicationAudiencePageBadges,
  newRecord: newAudienceRecord,
  recordAdapter: adaptAudience,
  toSavePayload: toAudiencePayload,
  beforeSave: countBeforeSave,
  fieldComponents: {
    // The body draws the rules itself. The config's field is there to be validated.
    communicationAudienceRules: () => null,
    communicationAudienceExportSize: AudienceExportSize,
    communicationAudienceExportDownload: AudienceExportDownload,
  },
  fieldValidators: {
    communicationAudienceRules: (_, record) =>
      Object.keys(validateRules(audienceRulesOf(record))).length > 0
        ? "Choose a rule and fill in its values, or delete the rule"
        : "",
  },
  visibilityRules: audienceVisibilityRules,
  identity: {
    titleFields: ["g4c_name"],
    subtitle: audienceTypeSummary,
    fallbackTitle: "Communication Audience",
    newRecordTitle: "New Communication Audience",
  },
};
